export class Sachgebiet{
    tid?: number;
    name?: string;
    rightname?: string; //wird noch nicht ausgewertet

    constructor (name?: string){
        this.name = name;
    }
}
